module.exports = __webpack_public_path__ + "img/36976466000174.d647b73e.png";